module.exports = __webpack_public_path__ + "static/img/40.4d0cf60.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/ADDomain/40.png
// module id = K0yz
// module chunks = 1